import { useCallback } from "react";

import { cn } from "@/lib/chillnn/cn";

import { RadioGroup, RadioGroupItem } from "@/components/ui/input/radio-group";

type PurchaseSwitchSectionProps = {
	isStopRecurringProBilling: boolean;
	onUpdateIsStopRecurringProBilling: () => void;
};

export const PurchaseSwitchSection = ({
	isStopRecurringProBilling,
	onUpdateIsStopRecurringProBilling,
}: PurchaseSwitchSectionProps) => {
	const currentValue = isStopRecurringProBilling ? "single" : "recurring";

	const handleValueChange = useCallback(
		(value: string) => {
			if (value === "single" && !isStopRecurringProBilling) {
				onUpdateIsStopRecurringProBilling();
			} else if (value === "recurring" && isStopRecurringProBilling) {
				onUpdateIsStopRecurringProBilling();
			}
		},
		[isStopRecurringProBilling, onUpdateIsStopRecurringProBilling],
	);

	return (
		<div className="space-y-6 rounded-md bg-zinc-100 p-4">
			<RadioGroup value={currentValue} onValueChange={handleValueChange} className="space-y-4">
				<label className="flex cursor-pointer items-start space-x-3">
					<RadioGroupItem value="single" id="purchase-single" className="mt-1.5" />
					<div className="flex-1 space-y-1">
						<p className={cn("font-medium", isStopRecurringProBilling && "font-semibold")}>
							１回のみ購入する
						</p>
						<div className="text-sm text-zinc-500">
							<p>
								一時的な繁忙期に対応する場合はこちらがおすすめ。チケットの有効期限を過ぎると自動的に従量課金型へ移行します。
							</p>
						</div>
					</div>
				</label>
				<label className="flex cursor-pointer items-start space-x-3">
					<RadioGroupItem value="recurring" id="purchase-recurring" className="mt-1.5" />
					<div className="flex-1 space-y-1">
						<p className={cn("font-medium", !isStopRecurringProBilling && "font-semibold")}>定期購入する</p>
						<p className="text-sm text-zinc-500">
							継続的に定額課金型を利用したい方はこちら。有効期限の7日前に料金が自動的に引き落とされます。
						</p>
					</div>
				</label>
			</RadioGroup>
		</div>
	);
};

PurchaseSwitchSection.displayName = "PurchaseSwitchSection";
